export default __webpack_public_path__ + "static/media/reglogin-bg.47512ba0.webp";